
import { BackendModule, ReadCallback } from 'i18next';
import { supabase } from '@/integrations/supabase/client';

export interface SupabaseBackendOptions {
  getCommunityId: () => string | null;
}

export const supabaseBackend = (options: SupabaseBackendOptions): BackendModule => ({
  type: 'backend',
  init: () => {},
  read: async (language: string, namespace: string, callback: ReadCallback) => {
    try {
      console.log('[supabaseBackend] Loading translations for language:', language);
      
      const communityId = options.getCommunityId();
      
      if (!communityId) {
        console.error('[supabaseBackend] No community ID available');
        callback(new Error('No community ID available'), null);
        return;
      }

      // First, get community-specific translations
      const { data: communityTranslations, error: communityError } = await supabase
        .from('community_translations')
        .select('translation_key, value')
        .eq('community_id', communityId)
        .eq('locale', language);

      if (communityError) throw communityError;

      // Get all default translations
      const { data: defaultTranslations, error: defaultError } = await supabase
        .from('translation_defaults')
        .select('key, default_value');

      if (defaultError) throw defaultError;

      // Create a map of default translations
      const resources = defaultTranslations.reduce((acc, { key, default_value }) => {
        acc[key] = default_value;
        return acc;
      }, {} as Record<string, string>);

      // Override with community-specific translations if they exist
      if (communityTranslations) {
        communityTranslations.forEach(({ translation_key, value }) => {
          resources[translation_key] = value;
        });
      }

      callback(null, resources);
    } catch (error) {
      console.error('[supabaseBackend] Error loading translations:', error);
      callback(error as any, null);
    }
  },
});
